import { type NumbersDO } from "./numbers.data"
import { type HttpAdapter } from "../core/adapters/axios.adapter"

export class NumberService {
  private readonly API_PATH = '/general'
  constructor(private numberAdapter: HttpAdapter) { }

  async load() {
    const response = await this.numberAdapter.get<NumbersDO>(this.API_PATH)
    return response.data
  }
}
